import { useFormik, Form, FormikProvider } from 'formik';
// material
import { Card, CardHeader, Stack, TextField, Box } from '@mui/material';
import * as Yup from 'yup';
import { useContext } from 'react';
// material
import { LoadingButton } from '@mui/lab';
// contexts
import { useAuth } from '../../../contexts/Auth';
import { SettingsContext } from '../../../contexts/Settings';
import { updateUser } from '../../../services/User';

export default function FormUser() {
  const { authUser } = useAuth();
  const { authSettings } = useContext(SettingsContext);

  const RegisterSchema = Yup.object().shape({
    name: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Name required'),
    email: Yup.string().email('Email must be a valid email address').required('Email is required')
  });

  const formik = useFormik({
    initialValues: {
      name: authUser.displayName,
      email: authUser.email
    },
    validationSchema: RegisterSchema,
    onSubmit: async (values) => {
      try {
        const idToken = await authUser.getIdToken();
        const headers = {
          Authorization: `Bearer ${idToken}`,
          'Account-Key': authSettings.server.path
        };
        const data = {
          displayName: values.name,
          email: values.email
        };

        const user = await updateUser(headers, data, authUser.uid);

        if (user.error) {
          console.error(user);
          alert('An error occurred! Please, refresh the page and try again.');
        }
      } catch (err) {
        console.error(err);
        alert('An error occurred! Please, refresh the page and try again.');
      }
    }
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <Card sx={{ mb: 3 }}>
      <CardHeader title="User" />
      <Box sx={{ m: 3 }} dir="ltr">
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                fullWidth
                label="First name"
                {...getFieldProps('name')}
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name && errors.name}
              />

              <TextField
                fullWidth
                type="email"
                label="Email address"
                {...getFieldProps('email')}
                error={Boolean(touched.email && errors.email)}
                helperText={touched.email && errors.email}
                disabled
              />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <LoadingButton
                  size="large"
                  type="submit"
                  variant="contained"
                  loading={isSubmitting}
                >
                  Save
                </LoadingButton>
              </Box>
            </Stack>
          </Form>
        </FormikProvider>
      </Box>
    </Card>
  );
}
